.ux-w-my-machines {
    display: block;

    .ux-w-wrapper__body {
        > div {
            display: flex;
        }
    }

    &__item {
        display: inline-flex;
        width: 305px;
        min-width: 305px;
        max-width: 305px;
        margin-right: 2px;

        &.ux-tile {
            box-shadow: none;
            display: flex;
            flex-direction: column;
        }

        &:nth-child(even) {
            background: $color-blue-menu-bg;
        }
    }

    .ux-tile-head {
        background-color: transparent;
    }

    .ux-tile-body {
        flex-grow: 1;
        overflow: hidden;
    }
}
